// const front_url = 'http://localhost:3000/';
const front_url = 'http://bbc.barriservices.com/';
export default front_url;
